export const NOTIFICATIONS_UPDATE_STATUS =
  "SOCKETS_NOTIFICATIONS_UPDATE_STATUS";
